import React from 'react';
import IconMinivanOutline from "@Icons/IconMinivanOuline";

function PrivateBusBadge() {
    return (
        <span className="gb--badge-blue">
            <IconMinivanOutline/>
            <span>Private bus</span>
        </span>
    )
}

export default PrivateBusBadge;